<template>
    <div>
		<el-tabs v-model="activeName" type="card">
			<el-tab-pane :label="this.$t('admin.adminmanage_title')" name="first"><AdminManage></AdminManage></el-tab-pane>
			<el-tab-pane :label="this.$t('admin.permissionmanage_title')"  name="second"><PermissionManage></PermissionManage></el-tab-pane>
		</el-tabs>
    </div>
</template>

<script>
	import AdminManage from '../../components/pages/adminManage/AdminManage';
	import PermissionManage from '../../components/pages/adminManage/PermissionManage';
    export default {
        name: "Admin",
		components:{
			AdminManage,
			PermissionManage
		},
        data() {
            return {
				activeName: 'first'
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style scoped>
    
</style>
